import { createServerFn } from "@tanstack/react-start";

import { VIEWER_LOCALES, type ViewerLocale } from "@garimpa/lib/viewerPreferences";

import type { Messages } from "./messages";

export interface FetchedMessages {
  locale: ViewerLocale;
  messages: Messages;
}

export const fetchMessages = createServerFn({ method: "GET" })
  .validator((value: unknown): ViewerLocale => {
    if (typeof value !== "string" || !(VIEWER_LOCALES as readonly string[]).includes(value)) {
      throw new Error(`Invalid locale: ${String(value)}`);
    }
    return value as ViewerLocale;
  })
  .handler(async ({ data: locale }): Promise<FetchedMessages> => {
    const { loadMessages } = await import("./resolve.server");
    return { locale, messages: await loadMessages(locale) };
  });
